import React from "react";
import classNames from "classnames";

import styles from "./index.module.scss";
import { Selector } from "../../atoms/inputSelector";

interface Props<Item> {
  options: Array<Item>;
  value: Array<Item>;
  setValue: (v: Array<Item>) => void;
  renderLabel: (i: Item) => string;
  toKey: (i: Item) => string | number;
  onBlur: () => void;
  checkboxClassName?: string;
  checkedClassName?: string;
  labelClassName?: string;
  className?: string;
  orientation?: "horizontal" | "vertical";
}

export function CheckBoxGroup<Item>(props: Props<Item>) {
  const {
    options,
    value,
    setValue,
    renderLabel,
    onBlur,
    toKey,
    checkboxClassName,
    labelClassName,
    checkedClassName,
    className,
    orientation = "horizontal",
  } = props;

  return (
    <div className={classNames(styles[orientation], className)}>
      {options.map((o) => {
        const checked = value.findIndex((v) => toKey(v) === toKey(o)) >= 0;

        return (
          <Selector
            checkedClassName={checkedClassName}
            checkboxClassname={checkboxClassName}
            labelClassname={labelClassName}
            key={toKey(o)}
            label={renderLabel(o)}
            checked={checked}
            onChange={() => {
              if (checked) {
                setValue(value.filter((v) => toKey(v) !== toKey(o)));
              } else {
                setValue([...value, o]);
              }
              onBlur();
            }}
          />
        );
      })}
    </div>
  );
}
